import * as React from "react";
import { DysplasiaList } from "../DysplasiaList";
import { ETLCodes } from "../../../locales";

export interface IAppealDysplasiaListProps {}

export const AppealDysplasiaList: React.FunctionComponent<IAppealDysplasiaListProps> = (props) => {
  return <DysplasiaList isAppeal={true} breadcrumbText={ETLCodes.Appeals} />;
};
